import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import { useTheme, alpha } from '@mui/material/styles';
import useMediaQuery from '@mui/material/useMediaQuery';
import KeyboardArrowDownRounded from '@mui/icons-material/KeyboardArrowDownRounded';


const About = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [showMore, setShowMore] = useState(false);
  const pearl = '#FFFFFF';
  const pearlGlass = alpha(pearl, 0.72);
  const texto = `Con más de 2 años de experiencia en gestión aduanera y más de 15 años de trayectoria en el comercio binacional, Acopiaserwa R.L. se ha consolidado como líder en soluciones logísticas internacionales en la región. Somos una cooperativa indígena wayuu comprometida con el comercio justo y el desarrollo económico fronterizo. Nuestro equipo de expertos brinda un servicio personalizado y eficiente a cada cliente, adaptándonos a sus necesidades para facilitar sus operaciones de importación y exportación.

Acopiaserwa es una de las primeras Agencias Aduaneras Indígenas autorizadas en Venezuela. Estamos avalados por el SENIAT para operar como agencia de aduanas ante la Aduana Principal de Maracaibo, lo que garantiza a nuestros clientes confianza y respaldo legal en cada trámite. Nos enorgullece impulsar el intercambio comercial entre Venezuela, Colombia y otros países, bajo un esquema que promueve el desarrollo de las comunidades locales y el comercio con identidad ancestral.`;

  const firstParagraph = texto.split('\n\n')[0];
  const rest = texto.split('\n\n').slice(1).join('\n\n');

  return (
    <Box id="sobre-nosotros" sx={{ py: 8 }}>
      <Container>
        <Typography
          variant="h3"
          component="h2"
          textAlign="center"
             sx={{
            mb: 4,
            fontWeight: 600,
          display: 'block',
            px: 2,
                  pt: 0.5,
            pb: 1.5,
            bgcolor: pearlGlass,
            color: 'text.primary',
            backdropFilter: 'blur(6px)',
            borderRadius: 1,
          }}
        >
          Sobre Nosotros
        </Typography>
        <Paper sx={{ p: 6, border: '1px solid rgba(0,0,0,0.05)' }}>
          <Grid container spacing={4} alignItems="center">
            <Grid item xs={12} md={6}>
              {isMobile ? (
                <>
                  <Typography variant="body1" sx={{ mb: 2, textAlign: 'justify' }}>
                    {firstParagraph}
                  </Typography>
                  {!showMore && (
                    <Button
                      size="small"
                      onClick={() => setShowMore(true)}
                      endIcon={<KeyboardArrowDownRounded />}
                    >
                      Seguir leyendo
                    </Button>
                  )}
                  {showMore && (
                    <Typography variant="body1" sx={{ mt: 2, textAlign: 'justify' }}>
                      {rest}
                    </Typography>
                  )}
                </>
              ) : (
                <Typography variant="body1" sx={{ textAlign: 'justify' }}>
                  {texto}
                </Typography>
              )}
            </Grid>
          <Grid item xs={12} md={6}>
            <Box
              component="img"
              src="/suministro.jpg"
              alt="Sobre nosotros"
              sx={{
                width: '100%',
                maxWidth: 480,
                mx: 'auto',
                display: 'block',
                borderRadius: 24,
                boxShadow: '0 8px 24px rgba(0,0,0,.18)',
                backdropFilter: 'saturate(120%) blur(2px)',
                WebkitBackdropFilter: 'saturate(120%) blur(2px)',
              }}
            />
          <Box display="flex" justifyContent="center" sx={{ mt: 2 }}>
              <Box textAlign="center" mr={{ xs: 1, md: 4 }}>
                <Typography variant="h3" sx={{ color: 'secondary.main', fontWeight: 700 }}>
                    2+
                </Typography>
                <Typography variant="body2">Años de Experiencia</Typography>
               </Box>
              <Box textAlign="center" mr={{ xs: 1, md: 4 }}>
                <Typography variant="h3" sx={{ color: 'secondary.main', fontWeight: 700 }}>
                  200+
                </Typography>
                <Typography variant="body2">Clientes Satisfechos</Typography>
                   </Box>
              <Box textAlign="center">
                <Typography variant="h3" sx={{ color: 'secondary.main', fontWeight: 700 }}>
                  3+
                </Typography>
                <Typography variant="body2">Países de Operación</Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
       </Paper>
    </Container>
  </Box>
);
};

export default About;